import React, { useState } from 'react';

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Urdu Literature Festival",
      description: "Annual celebration of Urdu literature and poetry",
      image: "https://images.unsplash.com/photo-1491975474562-1f4e30bc9468?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Digital Learning Center",
      description: "Modern facilities for digital education",
      image: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "Calligraphy Workshop",
      description: "Traditional Urdu calligraphy classes",
      image: "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      title: "Library Collection",
      description: "Extensive collection of rare manuscripts",
      image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 5,
      title: "Student Activities",
      description: "Interactive learning sessions",
      image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 6,
      title: "Research Center",
      description: "Advanced research facilities",
      image: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 7,
      title: "Cultural Programs",
      description: "Celebrating Urdu heritage",
      image: "https://images.unsplash.com/photo-1511735111819-9a3f7709049c?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 8,
      title: "Language Laboratory",
      description: "Modern language learning facilities",
      image: "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 9,
      title: "Academic Conferences",
      description: "International scholarly gatherings",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 10,
      title: "Manuscript Preservation",
      description: "Preserving historical documents",
      image: "https://images.unsplash.com/photo-1524578271613-d550eacf6090?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 11,
      title: "Community Events",
      description: "Engaging with local community",
      image: "https://images.unsplash.com/photo-1491975474562-1f4e30bc9468?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 12,
      title: "Guest Lectures",
      description: "Distinguished speakers and scholars",
      image: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 13,
      title: "Poetry Sessions",
      description: "Traditional Urdu poetry recitals",
      image: "https://images.unsplash.com/photo-1490633874781-1c63cc424610?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 14,
      title: "Book Exhibition",
      description: "Showcasing Urdu literature",
      image: "https://images.unsplash.com/photo-1526243741027-444d633d7365?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 15,
      title: "Student Symposium",
      description: "Young scholars presenting research",
      image: "https://images.unsplash.com/photo-1517486430290-35657bdcef51?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 16,
      title: "Cultural Exhibition",
      description: "Displaying Urdu art and culture",
      image: "https://images.unsplash.com/photo-1533654793924-4fc4949fb71e?auto=format&fit=crop&w=800&q=80"
    },
    
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  const getGridClasses = (index) => {
    // For every 5th item, span 2 columns
    if (index % 5 === 0) {
      return 'col-span-2';
    }
    // For other items, no span adjustments
    return '';
  };


  return (
    <>
      {/* Header Section */}
      <div className="relative pt-16">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt="Gallery Header" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Gallery</h1>
                <p className="text-xl">Explore the visual journey of AP State Urdu Academy</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    {/* Gallery Section */}
    <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-8">
          {/* Gallery Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 auto-rows-[160px]">
            {galleryItems.map((item, index) => (
              <div
                key={item.id}
                className={`relative overflow-hidden rounded-lg shadow-md cursor-pointer transform transition-transform duration-300 hover:scale-[1.02] ${getGridClasses(index)}`}
                onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-3 text-white transform translate-y-4 hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-sm font-bold mb-1 line-clamp-1">{item.title}</h3>
                    <p className="text-xs text-gray-200 line-clamp-2">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div 
            className="max-w-4xl w-full bg-white rounded-lg overflow-hidden shadow-2xl transform transition-all"
            onClick={e => e.stopPropagation()}
          >
            <div className="relative">
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="w-full max-h-[70vh] object-cover"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 bg-black/50 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-black/70 transition-colors"
              >
                ×
              </button>
            </div>
            <div className="p-4">
              <h3 className="text-xl font-bold text-blue-800 mb-2">{selectedImage.title}</h3>
              <p className="text-gray-600 text-sm">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;